import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';

export class cjsHook extends cjsItem {
  _isBusy;
  _idx;
  _idItem;

  constructor(obj) {
    let block = typeof obj[0].block === 'boolean' ? _.cloneDeep(obj[0].block) : obj[1].defConfig.itemsConfig.block;
    obj[0].stage = obj[1];
    obj[0].block = true;
    super(obj[0]);

    this.__block = block;
    this._isBusy = false;
  }

  create() {
    super.create();
    this._block = this.__block;
    delete this.__block;
  }

  get isBusy() {
    return this._isBusy;
  }
  set isBusy(v) {
    if (typeof v !== 'boolean')
      throw 'Wartość dla zmiennej isBusy w kotwicy: ' + this.id + ' jest: ' + typeof v + ' zamiast boolean';
    this._isBusy = v;
  }
  get idx() {
    return this._idx;
  }
  get idItem() {
    return this._idItem;
  }
}
